import { createFileRoute } from '@tanstack/react-router';
import { PromoterRequestDetailModule } from '@/modules/promoters/requests/request-detail';

export const Route = createFileRoute(
  '/dashboard/promoters/requests/$requestId'
)({
  component: PromoterRequestDetailModule,
});
